module.exports = __webpack_public_path__ + "img/wy.9575de93.png";